import { render, staticRenderFns } from "./processDes.vue?vue&type=template&id=33810384&scoped=true&"
import script from "./processDes.vue?vue&type=script&lang=js&"
export * from "./processDes.vue?vue&type=script&lang=js&"
import style0 from "./processDes.vue?vue&type=style&index=0&id=33810384&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33810384",
  null
  
)

export default component.exports